import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";

const CourseCard = ({ filtered, active, CoursesList }) => {
  const displayedCourses = filtered && active !== "ALL"
    ? CoursesList.filter((course) => course.courseTag === active)
    : CoursesList;

  return (
    <div className="row card-column-4">
      {displayedCourses.length > 0 ? (
        displayedCourses.map((courseItem) => (
          <div className="col-12" key={courseItem.id}>
            <div className="custom-course-card h-100">
              <Link to="" className="text-decoration-none">
                <div className="course-img-container">
                  <LazyLoadImage
                    src={courseItem.courseImg}
                    className="course-img img-fluid"
                    alt="Course Img"
                    effect="blur"
                  />
                  <div className="course-fav-icon">
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.11571 11.385C6.94288 11.446 6.65823 11.446 6.48541 11.385C5.01131 10.8817 1.71747 8.78242 1.71747 5.22426C1.71747 3.65358 2.98316 2.38281 4.54367 2.38281C5.46879 2.38281 6.28717 2.83012 6.80056 3.52142C7.31395 2.83012 8.13741 2.38281 9.05745 2.38281C10.618 2.38281 11.8836 3.65358 11.8836 5.22426C11.8836 8.78242 8.58981 10.8817 7.11571 11.385Z"
                        stroke="#F05203"
                        strokeWidth="1.52493"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </Link>
              <Link to="" className="text-decoration-none">
                <span className="course-badge px-11 py-3 my-10">
                  {courseItem.courseTag}
                </span>
              </Link>
              <Link to="" className="text-decoration-none">
                <h5 className="ah-text-xs text-black fw-bold text-capitalize">
                  {courseItem.courseTitle}
                </h5>
              </Link>
              <div className="d-flex align-items-center my-10">
                <div className="progress">
                  <div
                    className={`progress-bar w-100 ${
                      courseItem.id % 2 === 0 ? "bg-theme" : "bg-green"
                    }`}
                    role="progressbar"
                    aria-label="Success example"
                    aria-valuenow="100"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <h5 className="ah-text-xs text-black fw-bold ms-9 mb-0">100%</h5>
              </div>
              <Link to="" className="text-decoration-none">
                <div className="course-creator d-flex align-items-center">
                  <div className="creater-img">
                    <img src={courseItem.courseCreatorImg} alt="" />
                  </div>
                  <div className="creator-info ms-7">
                    <h5 className="ah-text-sm text-black fw-bold m-0 lh-sm">
                      {courseItem.courseCreatorName}
                    </h5>
                    <span className="text-muted fw-normal lh-sm ah-text-xs">
                      {courseItem.courseCreatorStack}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        ))
      ) : (
        <div className="col-12">
          <p>No courses found for this category.</p>
        </div>
      )}
    </div>
  );
};

export default CourseCard;